<template>
  <div id="ecgChart" style="width: 100%; height: 500px;"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated)

export default {
  props: {
    measurement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      if (!this.measurement || !this.measurement.measurementSeries) {
        console.error("Invalid measurement");
        return;
      }

      let chart = am4core.create("ecgChart", am4charts.XYChart);
      chart.paddingRight = 20;

      let xAxis = chart.xAxes.push(new am4charts.ValueAxis());
      xAxis.title.text = "Tempo";
      xAxis.renderer.minGridDistance = 50;

      let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
      yAxis.title.text = "ECG (mV)";

      this.measurement.measurementSeries.forEach((seriesData, index) => {
        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "value";
        series.dataFields.valueX = "interval";
        series.name = `ECG`;
        series.strokeWidth = 1;
        series.tooltipText = `{valueY}`;

        series.sequencedInterpolation = true;
        series.defaultState.transitionDuration = 0;
        series.stroke = chart.colors.next();
        series.tooltip.getFillFromObject = false;
        series.tooltip.background.fill = am4core.color("#000");

        series.data = seriesData.measurementValues.map(v => ({
          interval: v.interval,
          value: v.value
        }));
      });

      chart.legend = new am4charts.Legend();

      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarY = new am4core.Scrollbar();

      this.chart = chart;
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped lang="scss">

</style>
